import { mapToCanActivate, Routes } from '@angular/router';
import { coreRoutes } from '@next/core-lib/app';
import { LocationGuard } from '@next/core-lib/relationships';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { MeasurementsComponent } from './measurements/measurements.component';
import { MeasurementsEffects } from './measurements/store/measurements.effects';
import { measurementsReducer } from './measurements/store/measurements.reducer';

export const appRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/measurements',
  },
  {
    path: 'measurements',
    component: MeasurementsComponent,
    canActivate: mapToCanActivate([LocationGuard]),
    providers: [
      provideState('measurements', measurementsReducer),
      provideEffects([MeasurementsEffects]),
    ],
  },
  ...coreRoutes,
];
